import type { Color } from '../../../core/enums';
import type { Theme, Tools } from '../../../core/types';
import { useBreakpoint } from '../../styleless/breakpoint';
import { TabGroup as View } from './View';
import styles from './index.module.less';

export interface CTAProps {
  id?: string;
  qeId: string;
  tabPanelIndex: number;
  selected?: boolean;
  children?: React.ReactNode;
  onClick?: (i: string) => void;
  theme?: Theme;
  isActive?: boolean;
  tools?: Tools;
  tabsRef: React.MutableRefObject<HTMLButtonElement[]>;
  accentBarPosition?: 'top' | 'bottom';
  accentBarColor?: Customization['accentBarColor'];
}

export interface Customization {
  $accentBarPosition?: 'top' | 'bottom';
  accentBarColor?: Color.DeepBlue | Color.BrightBlue | Color.Gray06;
}

export interface TabContentComponentProps {
  id?: string;
  content?: React.ReactElement;
  isActive?: boolean;
}
export interface TabItem extends TabContentComponentProps {
  Component?: React.ComponentType<TabContentComponentProps>;
  trackingElement?: string;
  tabId: string;
}
interface TabButtonProps {
  data: {
    tabItems: TabItem[];
  };
  activeIndex: number;
  onIndexChange?: (tabState: TabContentComponentProps, index: number) => void;
  autoActivation?: boolean;
  customization?: Customization;
  qeId?: string;
  headerId?: string;
  shouldStayHorizontal?: boolean;
}

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to the new Tabs V2 when possible.
 */
export const TabGroup = ({
  data: { tabItems },
  customization,
  onIndexChange,
  autoActivation = true,
  activeIndex,
  qeId = 'TabGroup',
  headerId,
  shouldStayHorizontal = false,
}: TabButtonProps) => {
  const { sm } = useBreakpoint();
  return (
    <View
      qeId={qeId}
      headerId={headerId}
      tabItems={tabItems}
      activeIndex={activeIndex}
      onIndexChange={onIndexChange}
      autoActivation={autoActivation}
      customization={customization}
      isSmall={sm}
      shouldStayHorizontal={shouldStayHorizontal}
      styles={styles}
    />
  );
};
